var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoats = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Sea-Transport-Yacht--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Sea Transport Yacht Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.38 7 6 0.82c0.06 0 0.11 -0.06 0.11 -0.11s0.15 -1 0.15 -1a0.26 0.26 0 0 1 0.07 -0.15l2.13 -2A0.51 0.51 0 0 0 24 4a0.5 0.5 0 0 0 -0.41 -0.34l-3.06 -0.42a1.51 1.51 0 0 0 -1.11 0.29l-4.2 3.18c-0.09 0.07 -0.11 0.29 0.16 0.29Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.06 9.2 12.24 1.67a0.25 0.25 0 0 0 0.28 -0.21l0.17 -1.24a0.5 0.5 0 0 0 -0.43 -0.56l-9.58 -1.31A2.5 2.5 0 0 0 9.89 8L9 8.75a0.25 0.25 0 0 0 0.06 0.45Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.78 12.22 -21.55 -3a0.5 0.5 0 0 0 -0.5 0.76l2.72 4.34A4.42 4.42 0 0 0 7 16.24l1 0.18a0.68 0.68 0 0 0 0.36 -0.08A2.47 2.47 0 0 1 9.59 16a2.48 2.48 0 0 1 1.76 0.72 0.26 0.26 0 0 0 0.32 0L16 13.85a3.1 3.1 0 0 1 3.56 0 3 3 0 0 1 0.9 1.06 0.28 0.28 0 0 0 0.36 0.13l0.56 -0.24a2.94 2.94 0 0 1 2.31 0 0.26 0.26 0 0 0 0.31 -0.3v-2a0.25 0.25 0 0 0 -0.22 -0.28Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 16.13 -2.63 1.11a0.2 0.2 0 0 1 -0.25 -0.26c0.05 -0.16 0.09 -0.26 0.09 -0.26a1.52 1.52 0 0 0 -0.47 -1.65 1.46 1.46 0 0 0 -1.81 -0.07l-5.37 3.67a0.35 0.35 0 0 1 -0.26 0 1.51 1.51 0 0 1 -0.85 -0.69 1 1 0 0 0 -0.85 -0.49 1 1 0 0 0 -0.86 0.49 1.51 1.51 0 0 1 -1.3 0.76A1.5 1.5 0 0 1 6.15 18a1 1 0 0 0 -0.86 -0.49 1 1 0 0 0 -0.86 0.49 1.5 1.5 0 0 1 -1.29 0.76c-0.89 0 -1.14 -0.21 -1.28 -0.45a1 1 0 0 0 -1.72 1 3.29 3.29 0 0 0 3 1.43 3.48 3.48 0 0 0 2 -0.64 0.24 0.24 0 0 1 0.28 0 3.49 3.49 0 0 0 4 0 0.24 0.24 0 0 1 0.28 0 3.45 3.45 0 0 0 1.39 0.59 2 2 0 0 0 1.48 -0.34l3.85 -2.64c0.24 -0.16 0.21 0.1 0.21 0.1a1.53 1.53 0 0 0 0.39 1.57 1.44 1.44 0 0 0 1.6 0.29l3.07 -1.3c0.14 -0.06 0.27 0 0.27 0.13v0.3a1 1 0 0 0 2 0v-1.06a1.54 1.54 0 0 0 -0.42 -1.29 1.44 1.44 0 0 0 -1.54 -0.32Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoats);
export default ForwardRef;